import React, {useEffect, useState} from "react";

import {
    Button,
    CircularProgress, Space
} from "../../../../../common/components/libs";
import {observer} from "mobx-react";
import {useStores} from "../../../../../hooks";
import {
    localize,
    toLocalizedString,
} from "../../../../../common/libs";
import {useHistory} from "react-router-dom";
import {SnackbarType} from "../../../../../stores/common";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    InputLabel,
    MenuItem,
    OutlinedInput,
    RadioGroup,
    FormControl,
    Select, useMediaQuery, useTheme, DialogActions, FormControlLabel, Radio
} from "@material-ui/core";
import {Trans, useTranslation} from "react-i18next";
import style from "../style.module.css";
import {MenuFormType} from "../../../store/menu/forms";


const CopyMenuItemForm = () => {
    const {menuStore, generalStore, generalMenuStore} = useStores();
    const {open, current} = menuStore.forms.forms[MenuFormType.copyMenuItem];
    const {t} = useTranslation(["general", "menu"]);
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const category = menuStore.getCategoryById(current?.data.menuCategoryId);

    const [isCopyingItemInProgress, setIsCopyingItemInProgress] = useState(false);
    const [copyToThisMenu, setCopyToThisMenu] = useState(true);
    const [menuId, setMenuId] = useState<number | undefined>(undefined);
    const [categoryId, setCategoryId] = useState<number | undefined>(undefined);
    const [originalMenuId, setOriginalMenuId] = useState(menuStore.currentMenu.id)

    useEffect(() => {
        if (!current) return;
        if (menuId) menuStore.getCategoriesByMenuId(menuId);
        setMenuId(menuId);
        setCategoryId(categoryId);
    }, [current, menuId]);

    useEffect(() => {
        if(open){
            setOriginalMenuId(menuStore.currentMenu.id);
        }
    }, [open])

    if (!menuStore.currentMenu) return null;
    if (menuStore.currentMenu.menuCategories.length === 0) return null;
    if (!current) return;

    const forms = menuStore.forms;
    const closeForm = () => {
        setMenuId(undefined);
        forms.closeForm(MenuFormType.copyMenuItem);
    };

    const copy = async () => {
        setIsCopyingItemInProgress(true);
        let res;
        let newCategory;
        if (copyToThisMenu) {
            const newName = toLocalizedString(localize(current.data.name) + " (1)");
            res = await menuStore.createMenuItem({...current.data, name: newName});
            newCategory = category.id;
        } else {
            menuStore.setCurrentMenuId(menuId);
            await menuStore.fetchMenuById(menuId);

            if (!categoryId) {
                await menuStore.createCategory({
                    name: localize(category.data.name),
                    sortOrder: category.data.sortOrder,
                    workingSchedule: category.data.workingSchedule,
                    parentMenuCategoryId: null,
                    isInStopList: category.data.isInStopList,
                    categoryCookingTime: category.data.categoryCookingTime,
                });
                newCategory = menuStore.newCategoryId;
            } else {
                newCategory = categoryId;
            }
            res = await menuStore.createMenuItem({...current.data, menuCategoryId: newCategory});
        }
        if (!res) {
            const params: ({ type: SnackbarType, title: string, description?: string }) = {
                title: t("general:somethingWentWrong"),
                type: SnackbarType.error,
                description: t("general:tryAgain")
            }
            generalStore.showSnackbar(params);
        } else {
            setIsCopyingItemInProgress(false);
            generalStore.showSuccessSnackbar(t("menu:menuEditor.positionCopied"));
            await menuStore.fetchMenuById(originalMenuId);
            //history.push(`/menus/${menuStore.currentMenu.id}/${newCategory}/${res.menuItemId}`);
            menuStore.resetNewCategory();
            closeForm();
        }
    }

    const chooseToCopy = (fn: (value: any) => void) => {
        return (e: React.ChangeEvent<HTMLInputElement>) => {
            e.persist();
            e.stopPropagation();
            e.preventDefault();
            fn(e.target.value);
        };
    };

    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"md"}
            fullScreen={!isSm}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
            }}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:menuEditor.copyMenuItem")}
            </DialogTitle>
            <DialogContent>
                <FormControl component="fieldset">
                    <RadioGroup>
                        <FormControlLabel
                            onClick={() => {
                                setCopyToThisMenu(true)
                            }}
                            control={
                                <Radio
                                    checked={copyToThisMenu}

                                    value={copyToThisMenu}
                                />
                            }
                            label={t("menu:menuEditor.copyToThisMenu")}
                        />
                        <Space size={2}/>
                        <FormControlLabel
                            onClick={() => {
                                setCopyToThisMenu(false)
                            }}
                            control={
                                <Radio
                                    checked={!copyToThisMenu}

                                    value={!copyToThisMenu}
                                />
                            }
                            label={t("menu:menuEditor.copyToMenu")}
                        />
                    </RadioGroup>
                </FormControl>
                {!copyToThisMenu &&
                    <div className={style.copyToMenu}>
                        <FormControl fullWidth
                                     variant="outlined"
                                     className={style.chooseMenu}>
                            <InputLabel htmlFor="menu">
                                {t("menu:menuEditor.chooseMenu")}
                            </InputLabel>
                            <Select
                                value={menuId}
                                onChange={chooseToCopy(setMenuId)}
                                input={<OutlinedInput
                                    labelWidth={80}
                                />}
                            >
                                {
                                    generalMenuStore.menusList.map(menu => {
                                        return (
                                            <MenuItem value={menu.id} key={menu.id}>
                                                {localize(menu.data.name)}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                        <FormControl fullWidth
                                     variant="outlined"
                                     className={style.chooseMenu}>
                            <InputLabel htmlFor="menu">
                                {t("menu:menuEditor.chooseCategory")}
                            </InputLabel>
                            <Select
                                value={categoryId}
                                onChange={chooseToCopy(setCategoryId)}
                                input={<OutlinedInput
                                    labelWidth={80}
                                />}
                                disabled={!menuId}
                            >
                                {
                                    menuStore.categoriesList.map(category => {
                                        return (
                                            <MenuItem value={category.id} key={category.id}>
                                                {localize(category.data.name)}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </div>
                }

            </DialogContent>

            <DialogActions style={{paddingRight: 20, paddingBottom: 10}}>
                {
                    isCopyingItemInProgress &&
                    <Button
                        color="primary"
                        disabled
                    >
                        <CircularProgress
                            size={25}
                            color="secondary"
                        />
                    </Button>
                }
                <Button
                    color="default"
                    mr={3}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        closeForm()
                    }}
                >
                    {t("general:close")}
                </Button>
                {
                    !isCopyingItemInProgress &&
                    <Button
                        color="primary"
                        variant={'contained'}
                        mr={3}
                        onClick={copy}
                    >
                        {t("general:copy")}
                    </Button>
                }

            </DialogActions>
        </Dialog>
    );
};

export default observer(CopyMenuItemForm);
